import { Typography, Card, Grid, Box, Avatar } from "@mui/material"
import { cloneElement } from "react"

interface IProps {
  title?: string
  rows?: JSX.Element[]
  description?: JSX.Element
  fullWidth?: boolean
  action?: JSX.Element
  cardNumber?: number
  key?: number
}

const FormCard = ({title, rows, description, fullWidth, action, cardNumber, key}: IProps) => {
  return (
    <Box key={key} sx={{position: "relative", display: "inline-block", py: cardNumber ? 1 : 0}}>
      {
        cardNumber &&
        <Avatar sx={{width: 35, height: 35, bgcolor: 'primary.main', position:"absolute", top: "-14px", left: "-10px"}}>{cardNumber}</Avatar>  
      }
      <Card sx={{width: "100%", p: 2}} variant="outlined">
        <Typography variant="h6">{title}</Typography>
        {action}
        <Grid container justifyContent={"space-between"}>
          <Grid item xs={12} md={fullWidth ? 12 : 6}>
            {rows && rows.map((row, index) => cloneElement(row, {key: index + 1}))}
          </Grid>
          <Grid item xs={5} sx={{display: {xs: 'none', md: 'inline-block'}}}>
            {description}
          </Grid>
        </Grid>
      </Card>
    </Box>

  )
}

export default FormCard